<template>
  <li
    class="tab-controls-item"
    :class="{ '_is-disabled': disabled }"
    :tabIndex="selected ? 0 : -1"
    role="tab"
    @keydown.enter="handleKeyDown"
  >
    <slot />
  </li>
</template>

<script setup lang="ts">
interface Props {
  disabled?: boolean;
  selected?: boolean;
}

const { disabled = false, selected = false } = defineProps<Props>();

function handleKeyDown(evt: Event) {
  evt.preventDefault();
  (evt.target as HTMLElement)?.click();
}
</script>

<style lang="scss">
@import "@styles/layout/breakpoint";
@import "@styles/themes/sls-theme/tokens/colors";
@import "@styles/themes/sls-theme/tokens/spacing";
@import "@styles/themes/sls-theme/tokens/typo";

.tab-controls-item {
  @include carbon--type-style("productive-heading-01", true);
  display: flex;
  align-items: center;
  border-bottom: 4px solid $disabled-01;
  opacity: 0.5;

  @include media("mobile") {
    flex: 1;
    padding: $spacing-03 0;
  }

  @include media("tablet-min") {
    width: 260px;
    padding: $spacing-03;
  }

  &.active {
    opacity: 1;
    border-color: $interactive-03;
  }

  &.focus {
    opacity: 1;
    border-color: $interactive-03;
  }

  &._is-disabled {
    border-color: $disabled-02;
    opacity: 1;
    .title {
      color: $disabled-02;
    }
    &:active {
      pointer-events: none;
    }
    &:hover {
      cursor: not-allowed;
    }
  }

  &:hover {
    opacity: 1;
  }

  &:active {
    outline: 1px solid $focus;
    outline-offset: 1px;
  }

  .sls-icon {
    min-width: 32px;
    margin-right: $spacing-03;
  }

  .title {
    @include carbon--type-style("productive-heading-01", true);
  }
}
</style>
